module.exports = __webpack_public_path__ + "static/img/hair_03.a86824f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_03.png
// module id = WNGK
// module chunks = 0